import { Card } from '@latitude/card';
import {
  FormCheckbox,
  FormInput,
  FormSelect,
  useFormContext,
} from '@latitude/form';
import type { SelectOption } from '@latitude/select';
import { Text } from '@latitude/text';
import { PORTO_TERMS } from 'components/porto/Signup/constants';

type Props = {
  countryOptions: SelectOption[];
  isCountryOptionsLoading: boolean;
};

function CompleteYourProfileContent({
  countryOptions,
  isCountryOptionsLoading,
}: Props) {
  const { control } = useFormContext();

  return (
    <div className="flex w-full flex-col gap-10">
      <Card className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <FormInput
          wrapperClassname="col-span-full"
          control={control}
          name="mainUserEmail"
          label="Email"
          type="email"
          inputSize="medium"
        />
        <FormInput
          control={control}
          name="mainUserFirstName"
          label="First name"
          inputSize="medium"
        />
        <FormInput
          control={control}
          name="mainUserLastName"
          label="Last name"
          inputSize="medium"
        />
        <FormSelect
          wrapperClassname="col-span-full"
          control={control}
          name="mainUserCountry"
          label="Country of residence"
          options={countryOptions}
          loading={isCountryOptionsLoading}
          optional={false}
        />
      </Card>
      <div>
        <FormCheckbox
          control={control}
          checkboxLabel="I have read and accept the following:"
          name="mainUserCheckbox"
        />
        <ul className="ml-12 flex list-disc flex-col gap-2">
          {PORTO_TERMS.map(({ title, url }) => (
            <li key={title} className="text-color-ref-text-link-primary">
              <Text asChild className="hover:text-color-ref-text-strong">
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {title}
                </a>
              </Text>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export { CompleteYourProfileContent };
